import React from 'react';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import '../styles/PricingPage.css';
import { useNavigate } from 'react-router-dom';

const PricingPage = () => {
  const navigate = useNavigate();

  const handleGetPass = (duration) => {
    navigate('/payment', { state: { duration } });
  };

  return (
    <div className="pricing-page">
      <NavBar />
      <div className="pricing-container">
        <div className="pricing-header">
          <h1>🎤 Pocket Videoke - Pricing Plans</h1>
          <p className="subtitle">Sing all day, every day. Choose the perfect pass for your party!</p>
        </div>

        <div className="pricing-grid">
          {/* Free Plan */}
          <div className="pricing-card">
            <div className="card-badge trial">Always Free</div>
            <div className="card-header">
              <h2>Free</h2>
              <div className="price">
                <span className="currency">₱</span>
                <span className="amount">0</span>
              </div>
              <p className="plan-subtitle">Free access for everyone</p>
            </div>
            <div className="card-content">
              <ul className="features-list">
                <li>
                  <i className="fas fa-clock"></i>
                  <span>Unlimited 1-hour sessions</span>
                </li>
                <li>
                  <i className="fas fa-music"></i>
                  <span>Create karaoke sessions</span>
                </li>
                <li>
                  <i className="fas fa-plus-circle"></i>
                  <span>Add songs to queue</span>
                </li>
                <li>
                  <i className="fas fa-tv"></i>
                  <span>Cast to smart devices</span>
                </li>
                <li>
                  <i className="fas fa-check"></i>
                  <span>Basic features access</span>
                </li>
              </ul>
              <div className="best-for">
                <strong>👉 Perfect for:</strong> Casual karaoke, quick sessions, and first-time users
              </div>
              <button 
                className="plan-button"
                onClick={() => navigate('/sessions')}
              >
                Start Singing Free
              </button>
            </div>
          </div>

          {/* 6-Hour Pass */}
          <div className="pricing-card">
            <div className="card-badge trial">Try Pocket Videoke today</div>
            <div className="card-header">
              <h2>6-Hour Pass</h2>
              <div className="price">
                <span className="currency">₱</span>
                <span className="amount">149</span>
              </div>
              <p className="plan-subtitle">Quick parties & small gatherings</p>
            </div>
            <div className="card-content">
              <ul className="features-list">
                <li>
                  <i className="fas fa-music"></i>
                  <span>Unlimited song search</span>
                </li>
                <li>
                  <i className="fas fa-users"></i>
                  <span>Group session (up to 20 participants)</span>
                </li>
                <li>
                  <i className="fas fa-share-alt"></i>
                  <span>Join via shared session link</span>
                </li>
                <li>
                  <i className="fas fa-tv"></i>
                  <span>Chromecast / TV casting support</span>
                </li>
                <li>
                  <i className="fas fa-plus-circle"></i>
                  <span>Add songs to queue</span>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <span>Valid for 6 hours</span>
                </li>
              </ul>
              <div className="limitations">
                <p className="limitation-title">Limitations:</p>
                <p className="limitation-item">❌ No session rejoin after expiry</p>
                <p className="limitation-item">❌ Shorter playtime for long events</p>
              </div>
              <div className="best-for">
                <strong>👉 Perfect for:</strong> Birthdays, short hangouts, or first-time users
              </div>
              <button 
                className="plan-button"
                onClick={() => handleGetPass('6h')}
              >
                Get 6-Hour Pass
              </button>
            </div>
          </div>

          {/* 12-Hour Pass */}
          <div className="pricing-card">
            <div className="card-badge notice">Just ₱70 more for a full day</div>
            <div className="card-header">
              <h2>12-Hour Pass</h2>
              <div className="price">
                <span className="currency">₱</span>
                <span className="amount">229</span>
              </div>
              <p className="plan-subtitle">Half-day events & house parties</p>
            </div>
            <div className="card-content">
              <ul className="features-list">
                <li>
                  <i className="fas fa-music"></i>
                  <span>Unlimited song search</span>
                </li>
                <li>
                  <i className="fas fa-users"></i>
                  <span>Group session (up to 20 participants)</span>
                </li>
                <li>
                  <i className="fas fa-share-alt"></i>
                  <span>Join via shared session link</span>
                </li>
                <li>
                  <i className="fas fa-tv"></i>
                  <span>Chromecast / TV casting support</span>
                </li>
                <li>
                  <i className="fas fa-plus-circle"></i>
                  <span>Add songs to queue</span>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <span>Valid for 12 hours</span>
                </li>
              </ul>
              <div className="value-note">
                <p>💡 <strong>Value note:</strong> Only ₱70 more gets you a FULL DAY</p>
              </div>
              <div className="best-for">
                <strong>👉 Good,</strong> but most users upgrade to the daily pass
              </div>
              <button 
                className="plan-button"
                onClick={() => handleGetPass('12h')}
              >
                Get 12-Hour Pass
              </button>
            </div>
          </div>

          {/* 24-Hour Pass - Best Value */}
          <div className="pricing-card premium">
            <div className="popular-tag">MOST SULIT 🔥</div>
            <div className="card-header">
              <h2>⭐ 24-Hour Pass</h2>
              <div className="price">
                <span className="currency">₱</span>
                <span className="amount">299</span>
                <span className="period">/day</span>
              </div>
              <p className="plan-subtitle">All-day karaoke & celebrations</p>
              <div className="value-highlight">
                <p>💰 Only ₱12.50 per hour</p>
                <p>🏆 Most flexible & sulit option</p>
              </div>
            </div>
            <div className="card-content">
              <ul className="features-list">
                <li>
                  <i className="fas fa-music"></i>
                  <span>Unlimited song search</span>
                </li>
                <li>
                  <i className="fas fa-users"></i>
                  <span>Group session (up to 20 participants)</span>
                </li>
                <li>
                  <i className="fas fa-share-alt"></i>
                  <span>Join via shared session link</span>
                </li>
                <li>
                  <i className="fas fa-tv"></i>
                  <span>Chromecast / TV casting support</span>
                </li>
                <li>
                  <i className="fas fa-plus-circle"></i>
                  <span>Add songs to queue</span>
                </li>
                <li>
                  <i className="fas fa-redo"></i>
                  <span><strong>Rejoin session anytime within 24 hours</strong></span>
                </li>
                <li>
                  <i className="fas fa-clock"></i>
                  <span>Valid for 24 hours</span>
                </li>
              </ul>
              <div className="best-for premium-best-for">
                <strong>👉 Most Popular Choice</strong> - All-day karaoke, inuman sessions, events, sleep-overs 😄
              </div>
              <button 
                className="plan-button premium-button"
                onClick={() => handleGetPass('24h')}
              >
                Get 24-Hour Pass - Best Value!
              </button>
            </div>
          </div>

          {/* Monthly Pass */}
          <div className="pricing-card premium">
            <div className="popular-tag">BEST VALUE 🔥</div>
            <div className="card-header">
              <h2>⭐ Monthly Pass</h2>
              <div className="price">
                <span className="currency">₱</span>
                <span className="amount">999</span>
                <span className="period">/month</span>
              </div>
              <p className="plan-subtitle">Unlimited all-access karaoke all month</p>
              <div className="value-highlight">
                <p>💰 Less than ₱33 per day</p>
                <p>🏆 Unlimited all access for 30 days</p>
              </div>
            </div>
            <div className="card-content">
              <ul className="features-list">
                <li>
                  <i className="fas fa-infinity"></i>
                  <span><strong>Unlimited sessions and longer playtime for 30 days</strong></span>
                </li>
                <li>
                  <i className="fas fa-music"></i>
                  <span>Unlimited song search</span>
                </li>
                <li>
                  <i className="fas fa-users"></i>
                  <span>Group session (up to 20 participants)</span>
                </li>
                <li>
                  <i className="fas fa-share-alt"></i>
                  <span>Join via shared session link</span>
                </li>
                <li>
                  <i className="fas fa-tv"></i>
                  <span>Chromecast / TV casting support</span>
                </li>
                <li>
                  <i className="fas fa-plus-circle"></i>
                  <span>Add songs to queue</span>
                </li>
                <li>
                  <i className="fas fa-redo"></i>
                  <span><strong>Create new sessions anytime</strong></span>
                </li>
              </ul>
              <div className="best-for premium-best-for">
                <strong>👉 Best for:</strong> Regular karaoke lovers, frequent parties, and power users
              </div>
              <button 
                className="plan-button premium-button"
                onClick={() => handleGetPass('monthly')}
              >
                Get Monthly Pass - Best Value!
              </button>
            </div>
          </div>
        </div>

        {/* Pricing Summary Table */}
        <div className="pricing-summary">
          <h2>📊 Pricing Summary</h2>
          <div className="summary-table">
            <div className="table-header">
              <div>Plan</div>
              <div>Duration</div>
              <div>Price</div>
              <div>Cost per Hour</div>
            </div>
            <div className="table-row">
              <div><strong>6 Hours</strong></div>
              <div>6h</div>
              <div>₱149</div>
              <div>₱24.83</div>
            </div>
            <div className="table-row">
              <div><strong>12 Hours</strong></div>
              <div>12h</div>
              <div>₱229</div>
              <div>₱19.08</div>
            </div>
            <div className="table-row best-value-row">
              <div><strong>24 Hours</strong></div>
              <div>24h</div>
              <div>₱299</div>
              <div><strong>₱12.50 ⭐</strong></div>
            </div>
          </div>
        </div>

        <div className="pricing-faq">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>How does the 24-Hour Pass work?</h3>
              <p>The 24-Hour Pass gives you full access to all features for 24 hours from the time of purchase. You can rejoin your session anytime within this period.</p>
            </div>
            <div className="faq-item">
              <h3>What happens when my pass expires?</h3>
              <p>When your pass expires, you can purchase a new pass to create a new session and continue singing. Sessions cannot be extended after expiry.</p>
            </div>
            <div className="faq-item">
              <h3>Can I upgrade from a shorter pass?</h3>
              <p>Currently, passes cannot be upgraded. We recommend starting with the 24-Hour Pass for the best value and flexibility.</p>
            </div>
            <div className="faq-item">
              <h3>What payment methods do you accept?</h3>
              <p>We accept major credit cards, GCash, PayPal, and other popular payment methods in the Philippines.</p>
            </div>
            <div className="faq-item">
              <h3>Can multiple people use one pass?</h3>
              <p>Yes! One pass allows up to 20 participants to join the same session using a shared link. Everyone can add songs and enjoy together.</p>
            </div>
            <div className="faq-item">
              <h3>Is there a free option?</h3>
              <p>Yes. Everyone can create free 1-hour sessions. Paid passes unlock longer or unlimited access windows for extended karaoke sessions.</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PricingPage; 